export const ParticipationMessageConfig = {
    noDob: {
        validation: (participation) => {return !participation.person.dob},
    },
    trf: {
        validation: (participation) => {return participation.employments.find(emp => !emp.hiredDate)},
    },
}